<template>
  <mdb-container>
    <div class="text-left" v-if="currentGroup">
      <banner-small :group="currentGroup" title="Subscription Plans"/>
      <div v-if="showMain">
        <mdb-btn @click="addPlan" icon="plus-circle">Add Plan</mdb-btn>
        <a href="/page/subscriptions-help" target="_blank">Subscription Help<mdb-icon icon="external-link"/></a>

        <div v-if="plans.length>0">
          <mdb-tbl responsive striped>
            <mdb-tbl-head class="secondary-color">
              <tr>
                <th>Plan</th>
                <th>Frequency</th>
                <th>Price</th>
                <th>Base Membership</th>
                <th>Automatic on Join?</th>
                <th>Choose on Join?</th>
                <th>Subscriptions</th>
                <th></th>
                <th></th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr :key="i" v-for="(plan,i) in plans">
                <td>{{plan.planName}}</td>
                <td>{{plan.term}}</td>
                <td class="text-right">{{plan.priceFormatted}}</td>
                <td class="text-center">
                  <mdb-icon icon="check" v-if="plan.satisfiesMembership"/>
                </td>
                <td class="text-center">
                  <mdb-icon icon="check" v-if="plan.createOnJoin"/>
                </td>
                <td class="text-center">
                  <mdb-icon icon="check" v-if="plan.chooseOnJoin"/>
                </td>
                <td>{{plan.subscriptions}}</td>
                <td>
                  <mdb-btn @click="assign(plan)" icon="users" rounded size="sm">Assign to Members</mdb-btn>
                </td>
                <td>
                  <mdb-btn @click="editPlan(plan)" floating icon="pencil" size="sm" tag="a"/>
                  <mdb-btn @click="deletePlan(plan)" color="danger" floating icon="trash" size="sm"
                           type=""
                           tag="a" v-if="plan.subscriptions == 0"/>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </div>
        <div v-if="plans.length==0">
          No plans set up.
        </div>
      </div>

      <div v-if="showEdit">
        <mdb-card class="mb-4">
          <mdb-card-body>
            <mdb-input label="Plan Name" placeholder="Name" required type="text" v-model="editing.planName"/>
            <mdb-input id="baseMembership" label="Base Membership" type="checkbox"
                       v-model="editing.satisfiesMembership"/>
            <mdb-input id="createOnJoin" label="Automatic for New Members" type="checkbox"
                       v-model="editing.createOnJoin" :disabled="editing.chooseOnJoin"/>
            <mdb-input id="chooseOnJoin" label="Let Member Choose on Join" type="checkbox"
                       v-model="editing.chooseOnJoin" :disabled="editing.createOnJoin || !editing.satisfiesMembership"/>
            <div class="md-form">
              <label class="active">Term</label>
              <select class="browser-default gp-custom-select" id="term" v-model="editing.term">
                <option>Yearly</option>
                <option>Monthly</option>
                <option>Fixed Months</option>
              </select>
            </div>

            <mdb-input id="months" label="# of Months" placeholder="Number of Months" step="1"
                       type="number"
                       v-if="editing.term == 'Fixed Months'" v-model="editing.months"/>

            <mdb-input :step="0.01" label="Price" placeholder="Price" type="number" v-model="editing.price"/>

            <div class="md-form" v-if="editing.createOnJoin">
              <label class="active" for="endRule">For new members, when does it start?</label>
              <select class="browser-default gp-custom-select" id="startRule" v-model="editing.startRule">
                <option value="Actual">Actual Join Date</option>
                <option value="1st Curr Month">1st of Current Month</option>
                <option value="1st Next Month">1st of Next Month</option>
              </select>
            </div>

            <div class="md-form">
              <label class="active" for="endRule">When does it end?</label>
              <select class="browser-default gp-custom-select" id="endRule" v-model="editing.endRule">
                <option value="Actual">Actual Days</option>
                <option v-if="editing.term == 'Yearly'"
                        value="Following Year Fixed">Following Year Fixed Day/Month
                </option>
                <option v-if="editing.term == 'Yearly'"
                        value="Same Year Fixed">Same Year Fixed Day/Month
                </option>
                <option v-if="editing.term == 'Monthly' || editing.term == 'Fixed Months'"
                        value="End of Month">End of Month
                </option>
              </select>
            </div>

            <div class="md-form"
                 v-if="editing.term == 'Yearly' && editing.endRule == 'Following Year Fixed' || editing.endRule == 'Same Year Fixed'">
              <label class="active" for="fixedMonth">Fixed End Month</label>
              <select class="browser-default gp-custom-select" id="fixedMonth" v-model="editing.fixedMonth">
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </div>

            <mdb-input :max=31 :min=1 label="Fixed End Day"
                       type="number"
                       v-if="editing.term == 'Yearly' && (editing.endRule == 'Following Year Fixed' || editing.endRule == 'Same Year Fixed')"
                       v-model="editing.fixedDay"/>

            <div class="md-form"
                 v-if="editing.term == 'Yearly' && editing.endRule == 'Actual'">
              <label class="active" for="roundRule">Rounding Rule</label>
              <select class="browser-default gp-custom-select" id="roundRule" v-model="editing.roundRule">
                <option value="None">No Rounding</option>
                <option value="Up">Up to month end</option>
                <option value="Down">Down to prev month end</option>
              </select>
            </div>

            <div class="md-form">
              <label class="active" for="gracePeriodType">Grace Period Type</label>
              <select class="browser-default gp-custom-select" id="gracePeriodType" v-model="editing.gracePeriodType">
                <option value="None">None</option>
                <option value="Days"># Days</option>
                <option value="Months"># Months</option>
              </select>
            </div>

            <mdb-input :label="'Grace Period ' + editing.gracePeriodType" :step="1" id="gracePeriod" type="number"
                       v-if="editing.gracePeriodType != 'None'"
                       v-model="editing.gracePeriod"
            />

            <mdb-input
              :label="'Suspend membership when ' + (editing.gracePeriodType=='None' ? 'plan' : 'grace period') + ' ends.'"
              id="autoSuspendMembership"
              type="checkbox"
              v-model="editing.autoSuspendMembership"/>

            <div class="md-form">
              <label class="active" for="renewalType">Renewal Type</label>
              <select class="browser-default gp-custom-select" id="renewalType" v-model="editing.renewalType">
                <option value="Automatic">Automatic</option>
                <option value="Manual">Manual</option>
              </select>
            </div>

            <div v-if="editing.renewalType == 'Automatic'">
              <mdb-input :step="1" label="Days ahead to create renewed subscription" type="number"
                         v-model="editing.renewalPreDays"/>
              <mdb-input :rows="3" label="Renewal Text" type="textarea" v-if="editing.renewalPreDays>0"
                         v-model="editing.renewalText"/>

              <h5>Reminder 1</h5>
              <mdb-input :step="1" label="Days before expiration" type="number"
                         v-model="editing.reminder1DaysBefore"/>

              <div class="md-form" v-if="editing.gracePeriodType != 'None'">
                <label class="active" for="reminder1DateToUse">Expiration to Use</label>
                <select class="browser-default gp-custom-select" id="reminder1DateToUse"
                        v-model="editing.reminder1DateToUse.name">
                  <option value="SUBSCRIPTION_END">Subscription End</option>
                  <option value="GRACE_END">Grace Period End</option>
                </select>
              </div>

              <mdb-input :rows="3" label="Reminder 1 Text" type="textarea"
                         v-if="editing.reminder1DaysBefore>0"
                         v-model="editing.reminder1Text"/>

              <h5>Reminder 2</h5>
              <mdb-input :step="1" label="Days before expiration" type="number"
                         v-model="editing.reminder2DaysBefore"/>

              <div class="md-form" v-if="editing.gracePeriodType != 'None'">
                <label class="active" for="reminder2DateToUse">Expiration to Use</label>
                <select class="browser-default gp-custom-select" id="reminder2DateToUse"
                        v-model="editing.reminder2DateToUse.name">
                  <option value="SUBSCRIPTION_END">Subscription End</option>
                  <option value="GRACE_END">Grace Period End</option>
                </select>
              </div>

              <mdb-input :rows="3" label="Reminder 2 Text" type="textarea"
                         v-if="editing.reminder2DaysBefore>0"
                         v-model="editing.reminder2Text"/>
            </div>
            <mdb-btn @click="savePlan" color="success" icon="save">Save</mdb-btn>
            <mdb-btn @click.native="testModal=true" icon="bolt">Test Rule</mdb-btn>
            <mdb-btn @click="cancelEditing" color="danger" icon="times-circle">Cancel</mdb-btn>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>
    <yes-no-modal @no="deleteModal=false" @yes="doDelete" v-if="deleteModal"/>
    <mdb-modal @close="assignModal=false" size="lg" v-if="assignModal">
      <mdb-modal-header :close="true" class="primary-color text-white">
        Assign {{currentPlan.planName}} to Members
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div class="pageInstructions">
          This allows you to assign the subscription plan {{currentPlan.planName}} to
          all members of your group. It will only assign the plan to those who don't
          already have it actively assigned.
        </div>
        <div class="md-form">
          <div class="md-form">
            <div>
              <label class="active" for="startDateUse">Start Date to Assign</label>
              <select class="browser-default gp-custom-select" id="startDateUse" v-model="assignment.startDateUse">
                <option value="join">Joined Date (Actual)</option>
                <option value="joinAnniv">Join Date (Current Year Anniversary)</option>
                <option value="firstOf">First of....</option>
                <option value="current">Today</option>
                <option v-bind:value="'cust-actual-'+field.id"
                        v-for="field in customFields">{{field.label}} (Actual)
                </option>
                <option v-bind:value="'cust-current-'+field.id"
                        v-for="field in customFields">{{field.label}} (Curr Year)
                </option>
              </select>

              <div class="messageSummary" v-if="assignment.startDateUse.indexOf('cust-') != -1">
                Members without this custom date field set will be ignored during the assign process.
              </div>

            </div>

            <div class="fieldContain" v-if="assignment.startDateUse == 'firstOf'">
              <select class="browser-default gp-custom-select" v-model="assignment.firstOfMonth">
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
              <select class="browser-default gp-custom-select" v-model="assignment.firstOfYear">
                <option value="curr">This Year</option>
                <option value="next">Next Year</option>
              </select>
            </div>
          </div>
          <mdb-btn @click="runAssignment" color="success" icon="bolt" rounded size="sm">Execute Assignment Now</mdb-btn>
          <mdb-btn @click="assignModal=false" color="warning" icon="times-circle" rounded size="sm">Cancel</mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal @close="testModal=false" size="lg" v-if="testModal">
      <mdb-modal-header :close="true" class="primary-color text-white">
        Test {{editing.planName}} Rules
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <h5 class="text-info">{{testResults}}</h5>
        <datetime :auto="true"
                  :format="userDetails.dateFormat"
                  :use12-hour="userDetails.timeFormat=='AM/PM'"
                  :valueZone="userDetails.timezone"
                  :zone="userDetails.timezone"
                  :weekStart="userDetails.mondayFirst ? 1 : 7"
                  inputId="testDate" type="date"
                  v-model="testDate">
        </datetime>
        <mdb-btn @click="testPlan" icon="bolt">Test</mdb-btn>
        <mdb-btn @click="testModal = false" icon="times-circle">Done</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mapState} from 'vuex'
import bannerSmall from '../group/BannerSmall'
import gpSelect from "../common/GPSelect";

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import YesNoModal from "../common/YesNoModal";
import {Datetime} from 'vue-datetime'
import moment from 'moment'

export default {
    name: "group-subscription-plans",
    order: 1,
    components: {
      mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon, mdbBtn, mdbInput,
      mdbCard, mdbCardBody, mdbCardHeader,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      bannerSmall, YesNoModal, gpSelect, Datetime
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup,
                         userDetails: state => state.userDetails
                       }),
    data() {
      return {
        plans: [],
        customFields: [],
        currentPlan: null,
        editing: null,
        deleteCandidate: null,
        showMain: true,
        showEdit: false,
        deleteModal: false,
        assignModal: false,
        testModal: false,
        testResults: "",
        assignment: {
          planId: null,
          startDateUse: "join",
          firstOfMonth: "1",
          firstOfYear: "curr"
        },
        testDate: moment().format()
      }
    },
    mounted() {
      document.title = "Subscription Plans"
      if (!this.currentGroup) {
        api.groupBasics(this.$route.params.id, "public");
      }
      this.$store.dispatch("setExecuting", true)
      api.get("/group/plans/" + this.$route.params.id).then(
        (results) => {
          this.plans = results.data.plans
          this.customFields = results.data.customFields
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) {
            this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
            return
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      assign(plan) {
        this.currentPlan = plan
        this.assignment.planId = plan.id
        this.assignModal = true
      },
      deletePlan(plan) {
        this.deleteCandidate = plan
        this.deleteModal = true
      },
      doDelete() {
        this.deleteModal = false
        this.$store.dispatch("setExecuting", true)
        api.delete("/group/plans/" + this.$route.params.id + "?plan=" + this.deleteCandidate.id).then(
          (results) => {
            let loc = this.plans.indexOf(this.deleteCandidate)
            this.plans.splice(loc, 1)
          },
          (error) => {
            if (error.response.status == 403 || error.response.status == 401) {
              this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
              return
            }
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      savePlan() {
        this.$store.dispatch("setExecuting", true)
        delete this.editing['subscriptions']
        api.post("/group/plans/" + this.$route.params.id, this.editing).then(
          (results) => {
            if (this.editing.id) Object.assign(this.currentPlan, results.data)
            else (this.plans.push(results.data))
            this.showEdit = false
            this.showMain = true
            this.editing = null
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      runAssignment() {
        this.assignModal = false
        this.$store.dispatch("setExecuting", true)
        api.post("/group/assignPlans/" + this.$route.params.id, this.assignment).then(
          (results) => {
            this.currentPlan.subscriptions = results.data.subscriptions
          },
          (error) => {
            this.assignModal = true
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      testPlan() {
        this.$store.dispatch("setExecuting", true)
        this.editing.testDate = this.testDate
        api.post("/group/testPlan/" + this.$route.params.id, this.editing).then(
          (results) => {
            this.testResults = results.data
          },
          (error) => {
            this.assignModal = true
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      addPlan() {
        this.editing = {
          id: null,
          price: 0,
          term: "Yearly",
          endRule: "Following Year Fixed",
          fixedMonth: 12,
          fixedDay: 31,
          roundRule: "None",
          planName: "",
          satisfiesMembership: true,
          startRule: "Actual",
          renewalType: "Manual",
          createOnJoin: false,
          renewalType: "Manual",
          gracePeriodType: "None",
          autoSuspendMembership: false,
          gracePeriod: 0,
          reminder1DateToUse: {name: "SUBSCRIPTION_END"},
          reminder2DateToUse: {name: "SUBSCRIPTION_END"},
        }
        this.showMain = false
        this.showEdit = true
      },
      editPlan(plan) {
        this.currentPlan = plan
        this.editing = JSON.parse(JSON.stringify(plan));
        this.showMain = false
        this.showEdit = true
      },
      cancelEditing() {
        this.currentPlan = null
        this.editing = null
        this.showMain = true
        this.showEdit = false
      }

    }
  };

</script>

<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
